module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/ian_side.png
// module id = 2380
// module chunks = 2